import { UseFormReturn } from "react-hook-form";

import { useGlobalData } from "../../GlobalDataProvider";
import { IModuleRound, useRound } from "../../../modules/roundHandler";
import { IGlobalData, MapTooltip } from "../../../types/globalData";
import Funktionskontroller from "./Funktionskontroller";
import BFLNote from "./BFLNote";
import { bfl_J5_FTX_FT } from "../../../modules/Beräkningsmoduler/BFL_J5_FTX_FT";
import ErrorInfo from "./ErrorInfo";
import DebugInfo from "./DebugInfo";
import { Card, Table } from "react-bootstrap";
import DriftOptimeringar from "./DriftOptimeringar";
import { IJ5_FTX_FT_BFData } from "../../../types/BFDatas";
import NumberEditor from "../../Global/Editors/NumberEditor";
import { nameof } from "../../Global/Utils";
import TemperaturInfo from "./TemperaturInfo";
import SelectEditor from "../../Global/Editors/SelectEditor";
import { numFrmt1Dec } from "../../../modules/common";

interface IProps {
  module: IModuleRound;
  formHook: UseFormReturn;
}

const BFL_J5_FTX_FT = ({ module, formHook }: IProps) => {
  const roundHandler = useRound();
  const global = useGlobalData();

  const bimHandler = roundHandler.getBimHandler();

  formHook.watch(); //Rerender for any changes in inputs
  const formData: any = formHook.getValues();

  //if (module.bfs.BFL_J5_FTX_FT && formData.data) module.bfs.BFL_J5_FTX_FT.data = formData.data;
  const bm = bfl_J5_FTX_FT().getResult(module, bimHandler, roundHandler, global.data as IGlobalData, formData);

  const { funktionsKontroller, driftOptimeringar } = bm;
  const bflData = bm.data as IJ5_FTX_FT_BFData;

  const systemText = global.beräkningsflikarText.beskr_BFL_J5_FTX_FT;

  const moduleData = module.data;
  if (moduleData.ärHuvudsakligtVärmesystem !== "Ja") {
  }

  //Format bflData.export.optimalTilluftsTemp to 1 decimal
  const OptimalTilluftstemperatur = numFrmt1Dec.format(bflData.export.optimalTilluftsTemp);
  const AktuellTilluftstemperatur = numFrmt1Dec.format(bflData.export.aktuellTilluftsTemp);
  //Format bflData.export.aktuellTilluftsTemp to 1 decimal as a number
  const AktuellTilluftstemperaturNum = parseFloat(bflData.export.aktuellTilluftsTemp.toFixed(1));
  const OptimalTilluftstemperaturNum = parseFloat(bflData.export.optimalTilluftsTemp.toFixed(1));

  return (
    <div>
      <Card className="mb-3">
        <Card.Header>{systemText?.title}</Card.Header>
        <Card.Body>
          <div dangerouslySetInnerHTML={{ __html: systemText?.body as string }} />
          <Funktionskontroller bfName="BFL_J5_FTX_FT" formHook={formHook} funktionsKontroller={funktionsKontroller} />
          {bflData.export.temperaturInfo && <TemperaturInfo tempInfo={bflData.export.temperaturInfo.tempInfo} stickprov={bflData.export.temperaturInfo.stickprov} />}
          {bflData.export.driftOptimeringAktiv ? (
            <Card className="mb-3">
              <Card.Header>Manuella kontroller</Card.Header>
              <div className="row">
                <div className="col-lg-3 mt-1">Driftoptimering</div>
                <div className="col-lg-9 ps-4 pe-4">
                  <div className="row">
                    <Table bordered hover>
                      <tbody>
                        {moduleData.ärHuvudsakligtVärmesystem === "Ja" ? (
                          <></>
                        ) : (
                          <tr>
                            <th>Optimal tilluftstemperatur relativt medeltemperatur i lokal(°C)</th>
                            <td>{OptimalTilluftstemperatur}</td>
                          </tr>
                        )}
                        <tr>
                          <th>Aktuellt börvärde tilluftstemperatur(°C)</th>
                          <td>{AktuellTilluftstemperatur}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <SelectEditor
                    label="Ange ett nytt börvärde tilluft:"
                    formHook={formHook}
                    fieldName={"data." + nameof<IJ5_FTX_FT_BFData>("harAngettNyttVärdeTilluft")}
                    tooltipId={nameof<MapTooltip>("BFLJ5FTXoFT_harAngettNyttVärdeTilluft")}
                    items={["Nej", "Ja"]}
                  />
                </div>
                <div className="col-md-6">
                  <NumberEditor
                    label="Nytt börvärde tilluft:"
                    formHook={formHook}
                    isDisabled={formData.data?.harAngettNyttVärdeTilluft === "Ja" ? false : true}
                    fieldName={"data." + nameof<IJ5_FTX_FT_BFData>("nyttBörVärdeTilluft")}
                    tooltipId={nameof<MapTooltip>("BFLJ5FTXoFT_nyttBörVärdeTilluft")}
                    min={15}
                    max={20}
                    step={0.1}
                    options={{ required: "Måste fyllas i" }}
                  />
                </div>
              </div>
            </Card>
          ) : (
            <></>
          )}
          <DriftOptimeringar bfName="BFL_J5_FTX_FT" formHook={formHook} driftOptimeringar={driftOptimeringar} />
          <BFLNote formHook={formHook} />
          <ErrorInfo info={bm.error} />
          <DebugInfo info={bm.debug} />
        </Card.Body>
      </Card>
    </div>
  );
};

export default BFL_J5_FTX_FT;
